
import React, { Fragment, useEffect } from 'react';
import LinkOut from '../base/components/LinkOut';
import PropControl from '../base/components/PropControl';
import { getType } from '../base/data/DataClass';
import { getDataPath } from '../base/plumbing/DataStore';


export function MondayLink({board,item,path,type,canEdit=true, prop="crm", label="monday.com ID"}) {
	let mId = item && item.crm && item.crm.substring(0, item.crm.indexOf("@"));
	// NB: In reactstrap disabled is readonly
	// TODO support pasting a url and turning it into an XId
	return (<><PropControl label={label} item={item} path={path} prop={prop} type="XId" service="monday.com" disabled={ ! canEdit} />
		{mId && <LinkOut className="small" href={"https://good-loop.monday.com/boards/"+board+"/pulses/"+mId}>monday.com {type}</LinkOut>}</>);
}

export function MondayLinkOut({className, board, item, type}) {	
	let mId = item && item.crm && item.crm.substring(0, item.crm.indexOf("@"));
	if ( ! mId) return null;
	if ( ! type) type = getType(item);
	return <LinkOut className={className} href={"https://good-loop.monday.com/boards/"+board+"/pulses/"+mId}>monday.com {type}</LinkOut>;
}
